import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface ChipProps {
  variant?: "opted-in" | "opted-out" | "label";
  children: ReactNode;
  className?: string;
}

export function Chip({ variant = "label", children, className }: ChipProps) {
  if (variant === "label") {
    return (
      <span
        className={cn(
          "border-wg-03 bg-wg-02 text-wg-07 inline-flex items-center rounded-[10px] border px-2 py-0.5 text-[10px] font-semibold tracking-[0.06em] uppercase",
          className,
        )}
      >
        {children}
      </span>
    );
  }
  return (
    <span
      className={cn("font-semibold", variant === "opted-in" ? "text-ok" : "text-wg-06", className)}
    >
      {children}
    </span>
  );
}
